import React, { useState } from 'react';
import { Card, Table, Button, Tag, Space, Input, Select } from 'antd';
import { EditOutlined, DeleteOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';
import './AdminCommon.css';

const { Option } = Select;

const UserManagement = () => {
  const [users, setUsers] = useState([
    { id: 1, name: '张三', email: 'zhangsan@example.com', role: 'user', status: 'active', createdAt: '2026-05-01' },
    { id: 2, name: '李四', email: 'lisi@example.com', role: 'expert', status: 'active', createdAt: '2026-05-02' },
    { id: 3, name: '王五', email: 'wangwu@example.com', role: 'admin', status: 'active', createdAt: '2026-05-03' },
    { id: 4, name: '赵六', email: 'zhaoliu@example.com', role: 'user', status: 'banned', createdAt: '2026-05-04' },
  ]);

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    { title: '用户名', dataIndex: 'name', key: 'name' },
    { title: '邮箱', dataIndex: 'email', key: 'email' },
    { 
      title: '角色', 
      dataIndex: 'role', 
      key: 'role',
      render: (role) => (
        <Tag color={role === 'admin' ? 'red' : role === 'expert' ? 'blue' : 'default'}>
          {role === 'admin' ? '管理员' : role === 'expert' ? '专家' : '普通用户'}
        </Tag>
      )
    },
    { 
      title: '状态', 
      dataIndex: 'status', 
      key: 'status',
      render: (status) => (
        <Tag color={status === 'active' ? 'green' : 'red'}>
          {status === 'active' ? '正常' : '已封禁'}
        </Tag>
      )
    },
    { title: '注册时间', dataIndex: 'createdAt', key: 'createdAt' },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button 
            icon={record.status === 'active' ? <LockOutlined /> : <UnlockOutlined />} 
            size="small"
            danger={record.status === 'active'}
          >
            {record.status === 'active' ? '封禁' : '解封'}
          </Button>
          <Button icon={<EditOutlined />} size="small">编辑</Button>
          <Button icon={<DeleteOutlined />} size="small" danger>删除</Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="admin-page">
      <div className="page-header">
        <h1 className="page-title">用户管理</h1>
        <p className="page-subtitle">管理平台所有用户</p>
      </div>

      <Card>
        <div className="table-toolbar">
          <Space>
            <Input.Search placeholder="搜索用户" />
            <Select defaultValue="all" style={{ width: 120 }}>
              <Option value="all">全部角色</Option>
              <Option value="admin">管理员</Option>
              <Option value="expert">专家</Option>
              <Option value="user">普通用户</Option>
            </Select>
            <Select defaultValue="all" style={{ width: 120 }}>
              <Option value="all">全部状态</Option>
              <Option value="active">正常</Option>
              <Option value="banned">已封禁</Option>
            </Select>
          </Space>
        </div>
        <Table columns={columns} dataSource={users} rowKey="id" />
      </Card>
    </div>
  );
};

export default UserManagement;
